<script setup lang="ts">
import IconChevron from 'theme/components/atoms/icons/IconChevron.vue';
import VerticalCollapseTransition from 'theme/components/transitions/VerticalCollapseTransition.vue';

const isOpen = ref(false);
</script>

<template>
  <div :class="$style.accordion">
    <div :class="$style.accordion__header" @click="isOpen = !isOpen">
      <div :class="$style.accordion__title">
        <slot name="title" />
      </div>
      <div :class="$style['accordion__icon-wrapper']">
        <div :class="$style.accordion__icon">
          <IconChevron :direction="isOpen ? 'up' : 'down'" />
        </div>
        {{ isOpen ? '閉じる' : '表示する' }}
      </div>
    </div>
    <hr :class="$style.accordion__divider" />
    <VerticalCollapseTransition>
      <div v-show="isOpen" :class="$style.accordion__content">
        <slot />
      </div>
    </VerticalCollapseTransition>
  </div>
</template>

<style lang="scss" module>
.accordion {
  &__header {
    display: flex;
    justify-content: center;
    cursor: pointer;
  }

  &__title {
    flex-grow: 1;
    font-weight: bold;
  }

  &__icon-wrapper {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    color: $color-text-and-object-accent-primary;
    margin-left: 12px;
  }

  &__icon {
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__divider {
    flex: 0 0 auto;
    margin: 8px 0 0;
    border-top: 1px solid $color-border-low-emphasis;
    border-left: none;
    border-right: none;
    border-bottom: none;

    &:nth-last-child(n + 2) {
      margin-bottom: 16px;
    }
  }

  &__content {
    margin-top: 20px;
  }
}
</style>
